import { startListening, appSync, socketConnected } from '@bonanza-social/toolkit/state';
import { navigationRef } from '@bonanza-social/navigation';
import { getCoinBalance } from '@bonanza-social/wallet/state';
import {
  addReward,
  updateEvent,
  claimCommunityEventRewards,
  fetchCommunityEvents,
  openCommunityJackpot,
  selectCommunityJackpotDataState,
  selectIsCommunityJackpotVisible,
} from './communityJackpot.slice';
import {
  EventUpdatedNotification,
  RewardReceivedNotification,
} from './communityJackpot.types';

startListening({
  actionCreator: appSync,
  effect: (_, { dispatch }) => {
    dispatch(fetchCommunityEvents());
  },
});

startListening({
  actionCreator: openCommunityJackpot,
  effect: async (_, { condition, getState }) => {
    const dataState = selectCommunityJackpotDataState(getState());

    if (dataState === 'idle' || dataState === 'pending') {
      await condition(fetchCommunityEvents.fulfilled.match);
    }

    const isVisible = selectIsCommunityJackpotVisible(getState());

    if (isVisible) {
      navigationRef.navigate('CommunityJackpot');
    }
  },
});

startListening({
  actionCreator: claimCommunityEventRewards.fulfilled,
  effect: async (_, { dispatch, delay }) => {
    await delay(500); // Show coin balance update in a clean way after the community jackpot screen is closed

    dispatch(getCoinBalance());
  },
});

startListening({
  actionCreator: socketConnected,
  effect: (action, { dispatch }) => {
    const socketConnection = action.payload;

    socketConnection.on(
      'UpdatedCommunityEventContributions',
      (notification: EventUpdatedNotification) => {
        dispatch(updateEvent(notification.communityEvent));
      },
    );
  },
});

startListening({
  actionCreator: socketConnected,
  effect: (action, { dispatch }) => {
    const socketConnection = action.payload;

    socketConnection.on(
      'RewardMessageReceived',
      (notification: RewardReceivedNotification) => {
        const { rewards, sourceType, communityEventMeta } = notification || {};

        if (!rewards.length || !sourceType.startsWith('CommunityEvent')) {
          return;
        }

        const [{ rewardAmount, playerRewardId, expiryDate, sourceId }] =
          rewards;

        dispatch(
          addReward({
            rewardAmount: rewardAmount || 0,
            rewardId: playerRewardId || 0,
            expiryDate: expiryDate || '',
            milestoneId: sourceId || 1,
            rewardType: sourceType,
          }),
        );

        if (communityEventMeta) {
          dispatch(updateEvent(communityEventMeta));
        }

        navigationRef.navigate('CommunityJackpot');
      },
    );
  },
});
